export default Object.freeze({
    Error: 'error',
    Warning: 'warn'
});
